import Product, { IProduct } from './Product'
import ProductLite from './ProductLite'

export { type IProduct, ProductLite }

export default Product
